import AWS from 'aws-sdk';

AWS.config.update({ region: import.meta.env.VITE_AWS_REGION as string });
